















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class IconError extends Vue {

}
